<div *ngIf="documents$ | async as data" class="p-grid p-nogutter p-dir-col policy-documents-holder">
  <div *ngFor="let document of data" class="p-col line">
    <p class="p-nogutter align-center">
      <i class="fa fa-check primary-color"></i>
      {{document.totalYes}}
      <i class="fa fa-times text-danger"></i>
      {{document.totalNo}}
      <i class="fas fa-question" style="opacity: .5"></i>
      {{document.totalNone}}
      {{ document.documentName }}
    </p>
  </div>
</div>
